<template lang="pug">
  .absolute.inset-0(:class="{'p-72 flex': frmt === 'inset'}")
    //- poster (H1): the linked project's photograph, on screen within a moment on any connection.
    //- Stays put if the embed is slow or fails, so a slide is never blank.
    resp-img.home__poster(v-if="poster && show", :bg="true", :winLngth="0.8", :useHeight="isPortrait", :src="poster.url", :alt="poster.alt", :key="poster.url", :class="{'home__poster--hidden': started}")
    //- inset
    template(v-if="frmt === 'inset'")
      .relative.w-full.z-0
        vimeo-player(ref="vimeo", :vimeoURL="vimeoURL", bgSize="contain", @loaded="onLoaded", :clip="clip", @firstplay="onFirstPlay", @error="onError", v-if="loadVimeo", :visible="visible", :key="vimeoURL")
    //- full bleed
    template(v-else)
      vimeo-player.z-0(ref="vimeo", :vimeoURL="vimeoURL", bgSize="cover", @loaded="onLoaded", :clip="clip", @firstplay="onFirstPlay", @error="onError", v-if="loadVimeo", :visible="visible", :key="vimeoURL")
</template>

<script>
import Vue from 'vue'
import { mapGetters, mapState } from 'vuex'
import VimeoPlayer from '@/components/VimeoPlayer'
import RespImg from '@/components/RespImg'
import get from 'lodash/get'
export default {
  name: 'Slide--Vimeo',
  props: ['slice', 'visible', 'index', 'preload', 'near', 'muted'],
  components: { VimeoPlayer, RespImg },
  data () {
    return {
      started: false, // the video has shown a frame: the poster can fade away
      shown: false // this slide has been on screen at least once
    }
  },
  computed: {
    // the poster is fetched a little further ahead than the player (near: two slides either way)
    show () {
      return this.visible || this.preload || this.near || this.shown
    },
    poster () {
      const img = get(this.slice, 'primary.link_to.data.index_image')
      return img && img.url ? img : null
    },
    ...mapGetters(['isPortrait']),
    ...mapState(['winW']),
    // the portrait reel is for phones only (B1)
    usePortrait () {
      return this.isPortrait && this.winW < Vue.config.bkpts.md
    },
    vimeoURL () {
      const lnd = get(this.slice, 'primary.vimeo_url.url')
      const prt = get(this.slice, 'primary.vimeo_url_portrait.url')
      return this.usePortrait && prt ? prt : lnd
    },
    // only the current and the next slide hold a player (H1); anything further away is destroyed
    loadVimeo () {
      return !!this.vimeoURL && (this.visible || this.preload)
    },
    clip () {
      return [this.slice.primary.vimeo_clip_start, this.slice.primary.vimeo_clip_end]
    },
    frmt () {
      return this.slice.primary.format
    }
  },
  methods: {
    get,
    onLoaded () {
      if (!this.visible) return this.$refs.vimeo && this.$refs.vimeo.pause()
      this.applyVolume()
    },
    onFirstPlay () {
      // the video is showing imagery: fade the poster out and let the slideshow start its countdown
      this.started = true
      this.$emit('ready')
    },
    onError (err) {
      console.warn('Selected Works: Vimeo embed failed', this.vimeoURL, err)
      this.$emit('error', err)
    },
    applyVolume () {
      const player = this.$refs.vimeo
      if (player && player.setMuted) player.setMuted(this.muted)
    }
  },
  watch: {
    visible (vis) {
      if (vis) this.shown = true
      const player = this.$refs.vimeo
      if (!player) return
      // hidden slides stop streaming instead of playing on behind the active one
      if (vis) {
        player.play()
        this.applyVolume()
      } else {
        player.pause()
      }
    },
    loadVimeo (load) {
      if (load) return
      // the player is destroyed once the slide is more than one away: bring the poster back, or
      // swiping back to this slide would show an empty frame until the video loads again
      this.started = false
      this.$emit('unready')
    },
    muted () {
      this.applyVolume()
    }
  }
}
</script>

<style>
/* above the player until the video is actually playing: a preloaded neighbour sits paused (often a
   black frame), so with the poster underneath, swiping onto it flashed that frame before playback */
.home__poster {
  z-index: 1;
  pointer-events: none;
  transition: opacity 600ms ease;
}
.home__poster--hidden {
  opacity: 0;
}
</style>
